module.exports = {
      id: "share-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite.svg#share",
      toString: function () {
        return this.url;
      }
    }